import React, {Component} from 'react';
import Hit from '../../components/Hit';

class BestMatchHit extends Component {
    onClick = () => {
        this.props.onClick(this.props.index);
    }

    render() {
        return (
            <div
                className="hit-container"
                onClick={this.onClick}
                onKeyPress={this.onClick}
                role="button"
                tabIndex="0"
            >
                <Hit miniHit {...this.props.hit} />
            </div>
        );
    }
}

export default BestMatchHit;



// WEBPACK FOOTER //
// ./src/universal/recent-activity/components/best-match-hit.js